import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, email, length, min_value, max_value, double, numeric, alpha } from 'vee-validate/dist/rules'
import { EMPTY_VALUES } from '@/constants/emptyValues'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

extend('required', {
  ...required,
  message: 'This field is required'
})
extend('email', {
  ...email,
  message: 'This field must be a valid email address'
})
extend('length', {
  ...length,
  message: 'This field must be {length} characters long'
})

extend('min_value', {
  ...min_value,
  message: 'This field must be at least {min}'
})

extend('max_value', {
  ...max_value,
  message: 'This field must be at most {max}'
})

extend('positive_integer', {
  validate: (value) => {
    return +value >= 0
  },
  message: 'This field must be a valid positive integer'
})

extend('uuidv4', {
  validate: (value) => {
    return /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.test(value)
  },
  message: 'This field must be a valid UUID v4'
})

extend('uuidv7', {
  validate: (value) => {
    return /^[0-9A-F]{8}-[0-9A-F]{4}-7[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.test(value)
  },
  message: 'This field must be a valid UUID v7'
})

extend('phone', {
  validate: (value) => {
    return /^\+[1-9]\d{4,14}$/.test(value)
  },
  message: 'This field must be a valid phone number including "+", country code and your number'
})

extend('double', {
  ...double,
  message: 'This field must be a valid decimal'
})

extend('numeric', {
  ...numeric,
  message: (_, { _value_ }) => {
    if (Array.isArray(_value_)) {
      return 'This field must contain only numbers'
    }

    return 'This field must be a valid positive number'
  }
})

extend('unique_threshold', {
  params: ['thresholds'],
  validate: (value, { thresholds }) => {
    const thresholdsArray = []

    if (Array.isArray(thresholds)) {
      thresholdsArray.push(...thresholds)
    } else if (thresholds) {
      thresholdsArray.push(thresholds)
    }

    if (EMPTY_VALUES.includes(value) || !thresholds) {
      return true
    }

    const duplicateCount = thresholdsArray.filter(t => parseFloat(t.threshold) === parseFloat(value)).length
    return duplicateCount <= 1
  },
  message: 'This threshold amount is already used'
})

extend('no_digits', {
  validate: (value) => {
    return /^[^\d]*$/.test(value)
  },
  message: 'This field cannot contain any numbers'
})
